export default __webpack_public_path__ + "static/media/User.9d832826.svg";